import React from "react";
import { Grid } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import Switch from '@material-ui/core/Switch';

const YellowSwitch = withStyles({
  switchBase: {
    color: "#FFDC00",
    '&$checked': {
      color: "#FFDC00",
    },
    '&$checked + $track': {
      backgroundColor: "#FFDC00",
    },
  },
  checked: {},
  track: {},
})(Switch);

function InstyleSwitch(props) {

  function handleChange(event) {
    if (props.onToggle) {
      props.onToggle(!props.checked);
    }
  }

  return (
    <Grid container alignItems="center" style={{width: "100%", justifyContent: "center"}} spacing={1}>
      <Grid item>{props.LeftLabel}</Grid>
      <Grid item>
        <YellowSwitch
          checked={props.checked}
          onChange={handleChange}
          value="checked"
        />
      </Grid>
      <Grid item>{props.RightLabel}</Grid>
    </Grid>
  )
}

export default InstyleSwitch;